module.exports = __webpack_public_path__ + "img/completeInitSetting.ecdbf8ef.svg";